import React, { createContext, useContext, useEffect } from "react";
import useSessionTherapyContext from "lib/hooks/useSessionTherapyContext";
import { AppContext } from "./app-context";
import useLocalStorage from "lib/hooks/useLocalStorage";
import { Navigate, useNavigate } from 'react-router-dom';

// Types for context value
type SessionBookingContextType = ReturnType<typeof useSessionTherapyContext>;

const SessionBookingContext = createContext<SessionBookingContextType | null>(null);

const SessionBookingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useSessionTherapyContext();
  const { appState } = useContext(AppContext);
  const { clearAll } = useLocalStorage();
  const navigate = useNavigate();


  useEffect(() => {
    if (
      appState?.userRole === 'patient' ||
      appState?.userRole === 'practitioner'
    ) {
      clearAll();
      navigate('/');
    }
  }, [appState?.userRole, clearAll, navigate]);

  return (
    <SessionBookingContext.Provider value={value}>
      {children}
    </SessionBookingContext.Provider>
  );
};

// Optional: custom hook for easier usage
const useSessionBooking = () => {
  const ctx = useContext(SessionBookingContext);
  if (!ctx) throw new Error("useSessionBooking must be used within a SessionBookingProvider");
  return ctx;
};

export { SessionBookingContext, SessionBookingProvider, useSessionBooking };
